module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"requerido":"Requerido","anyadir_muestreos":"Añadir muestreos","anyadir_muestreos_descrip":"Selecciona un fichero excel que incluya los muestreos","anyadir":"Añadir","cerrar":"Cerrar","error_muestreos":"Error en muestreos","error_desconocido":"Se ha producido un error desconocido al procesar los muestreos"}}')
  delete Component.options._Ctor
}
